"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../components");

var _dataProcessors = require("../../../utils/dataProcessors");

var _HoursModule = _interopRequireDefault(require("./Hours.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Hours = function Hours(_ref) {
  var labelThemeType = _ref.labelThemeType,
      label = _ref.label,
      open = _ref.open,
      close = _ref.close,
      displayHour = _ref.displayHour;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _HoursModule["default"].hours
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelThemeType
  }, "".concat(label, ":"))), "\xA0", /*#__PURE__*/_react["default"].createElement("span", null, displayHour ? /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelThemeType
  }, displayHour) : open && close ? /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelThemeType
  }, "".concat((0, _dataProcessors.toCivilianTime)(open), "-").concat((0, _dataProcessors.toCivilianTime)(close))) : /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelThemeType
  }, "Closed")));
};

var _default = Hours;
exports["default"] = _default;